<template>
    <Forms ref="frmSearch"
            title="Busca por Template"
            :showHelp="true"
            :showClearButton="true"
            :showSearchButton="true"
            :showNewButton="false"
            :ShowFooterImbo="true"
            :messageTipFooter="$lang.Common.SelectOrEnterInformationToSearch"
            v-on:Clear="onClearSection"
            v-on:Search="Search"
            >
             <div style="width: 100%;">
              <label class="labelsearch">Código {{TipoQmaTemplate}}</label>
              <b-input v-model="form.Qma"  :placeholder="'Insira o número ' + TipoQmaTemplate" />
             </div>

            <label class="labelsearch margem">Status do Template</label>
            <select v-model="form.TipoStatus" name="statusVistoria" class="form-control" id="exampleFormControlSelect2">
                <option :value = null disabled>Selecione o status</option>
                <option v-for="data in dataStatusQMATemplate" v-bind:key="data.value" :value="data.value">{{data.text}}</option>
            </select>

            <div class="labelsearch mt-3" for="txtInsured">Data de criação</div>

            <div class="labelsearch mt-3" for="txtInsured">Desde</div>
            <div class="margem-buton d-flex align-items-end">
                <b-form-datepicker
                v-model="form.InicioDataSolicitacao"
                ref="dataInicio"
                placeholder="__/__/__"
                locale="pt-BR"
                today-button
                label-today-button="Hoje"
                reset-button
                label-reset-button="Limpar"
                close-button
                label-close-button="Fechar"
                :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                ></b-form-datepicker>
            </div>
            <label class="labelsearch mt-3" for="txtInsured">Até</label>
            <div class="d-flex align-items-end">
                <b-form-datepicker
                v-model="form.FimDataSolicitacao"
                ref="dataFim"
                placeholder="__/__/__"
                locale="pt-BR"
                today-button
                label-today-button="Hoje"
                reset-button
                label-reset-button="Limpar"
                close-button
                label-close-button="Fechar"
                :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                ></b-form-datepicker>
            </div>
    </Forms>
 </template>

<script>
import templateFilter from './templateFilter'
export default templateFilter
</script>

 <style scoped>
 .labelsearch{
   font-weight: 700;
   color: #666;
   font-size: 14px;
   margin-bottom: 5px;
   padding-bottom: 0;
   font-family: Segoe UI;
 }
 .margem-buton{
   margin-bottom: 0.5rem;
 }

 .margem{
   margin-top: 0.5rem;
 }
 </style>



// WEBPACK FOOTER //
// src/views/private/qma/qmaTemplate/TemplateFilter/templateFilter.vue